import { Directive, OnInit, OnDestroy, ElementRef, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[ngxMatTimepicker]'
})
export class TimeInputDirective implements OnInit, OnDestroy {
  constructor(
    private elementRef: ElementRef,
    @Optional() @Self() private ngControl: NgControl
  ) {}

  ngOnInit(): void {
    this.elementRef.nativeElement.addEventListener('change', this.handleCaptureChange, true);
  }

  ngOnDestroy(): void {
    this.elementRef.nativeElement.removeEventListener('change', this.handleCaptureChange, true);
  }

  private handleCaptureChange = (event: Event) => {
    event.stopImmediatePropagation();
    const input = event.target as HTMLInputElement;
    let time = input.value;
    if (time && !time.includes(':')) time = `${time.padStart(2, '0')}:00`;
    input.value = time;
    if (this.ngControl && this.ngControl.control) {
      this.ngControl.control.setValue(time);
      this.ngControl.control.markAsTouched();
    }
  };
}
